export const SubCategoryNames = {
    BIG: 'Big',
    SMALL: 'Small'
}



// WEBPACK FOOTER //
// ./src/constants/subCategoryNames.ts